import { post, search } from './rest';

const rootUrl = `${process.env.API_URL}/remediation`;

export default {
	// eslint-disable-next-line no-underscore-dangle
	get: id => search(`${rootUrl}/${id}`),
	create: remediation => post(`${rootUrl}`, remediation)
};
